import { Dialog, DialogActions, DialogTitle, DialogContent } from "@mui/material";
import { useHistory } from "react-router";

export const SwitchTabWarningDialog = ({ showDialog, setShowDialog, pageToRedirectTo }) => {
  const history = useHistory();

  return (
    <Dialog fullWidth={true} maxWidth={"xs"} open={showDialog}>
      <DialogContent style={{ background: "rgb(245 245 245)" }}>
        <div className="flex">
          <div>Leaving this page will discard any unsaved changes. Are you sure you want to proceed?</div>
        </div>
      </DialogContent>
      <DialogActions style={{ background: "rgb(245 245 245)" }}>
        <button
          style={{ minWidth: "100px" }}
          className={"border-blue-600 bg-blue-600 text-gray-100 border cursor-pointer rounded-md p-1 text-sm font-semibold"}
          type="submit"
          variant="contained"
          size="large"
          onClick={() => {
            setShowDialog(false);
            history.push(pageToRedirectTo);
            setShowDialog(false);
          }}
        >
          <span>Yes</span>
        </button>
        <div className="ml-2 flex justify-between text-center">
          <div
            style={{ minWidth: "100px" }}
            className="border border-gray-600 rounded-md text-gray-900 p-1 text-sm cursor-pointer font-semibold"
            type="submit"
            variant="contained"
            size="large"
            onClick={() => setShowDialog(false)}
          >
            <span>Cancel</span>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};
